import React, { useState, useEffect, memo } from "react";
import { handleErrors } from "../services/dataManager";
import { useNavigate } from "react-router-dom";
import {
  fetchNotificationsList,
  markAllNotifAsRead,
  markOneNotifAsRead,
} from "../services/axios/apiManager";
import DashboardLayout from "../Pages/DashboardLayout";
import { baseURL } from "../services/axios/eps";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { useAppContext } from "../services/context";
import BSPagination from "./pagination";
import { Button } from "react-bootstrap";
import LoadingSpinner from "./spinner";
import { format } from "date-fns";

// Custom Accordion Item Component
const AccordionItem = memo(({ item, isOpen, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  const headerStyle = {
    width: "100%",
    padding: "10px 20px",
    textAlign: "left",
    background: isHovered ? "#3a3a3a" : "#1e1e1e",
    border: "none",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
    transition: "background 0.2s ease",
    color: "#f0f0f0",
  };
  return (
    <div className="accordionItem" style={styles.accordionItem}>
      <button
        onClick={onClick}
        style={headerStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        aria-expanded={isOpen}
      >
        <span>{item.title}</span>

        <div style={styles.chevronContainer}>
          <span style={styles.notificationDate}>
            {item?.createdAt && format(item.createdAt, "PPpp")}
          </span>
          <span style={styles.chevron}>
            {isOpen ? <FaChevronUp /> : <FaChevronDown />}
          </span>
          {!item?.is_read && <span style={styles.unreadDot} />}
        </div>
      </button>
      <div
        className="accordion-content"
        style={{
          ...styles.accordionContent,
          ...(isOpen
            ? styles.accordionContentOpen
            : styles.accordionContentClosed),
        }}
      >
        <div style={styles.accordionBody}>
          {item.message}

          {item.image_url && (
            <img
              src={`${baseURL}uploads/file/${item.image_url}`}
              alt={item.title || "notification image"}
              style={styles.notificationImage}
            />
          )}
        </div>
      </div>
    </div>
  );
});

const Notifications = () => {
  const navigate = useNavigate();
  const { state, setState } = useAppContext();
  const { notifsCount } = state;
  const [notificationsList, setNotificationsList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [markingAsRead, setmarkingAsRead] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);

  const getNotificationsList = async (pgn) => {
    const res = await fetchNotificationsList(
      pgn?.currentPage || 1,
      pgn?.pageSize || 50
    );
    if (res?.data?.success && res?.data?.data) {
      setNotificationsList(res.data.data);
      setPagination(res?.data?.pagination || {});
    } else {
      handleErrors(res, navigate);
    }
  };

  useEffect(() => {
    getNotificationsList();
  }, []);

  const toggleAccordion = async (index, id, is_read) => {
    setOpenIndex(openIndex === index ? null : index);
    if (!is_read) {
      await markOneNotifAsRead(id);
      setNotificationsList((prev) =>
        prev.map((item) => (item.id === id ? { ...item, is_read: 1 } : item))
      );
      setState((prev) => ({ ...prev, notifsCount: notifsCount - 1 }));
    }
  };

  const handleMarkAllAsRead = async () => {
    setmarkingAsRead(true);
    const res = await markAllNotifAsRead();
    if (res?.data?.success) {
      await getNotificationsList();
      setState((prev) => ({ ...prev, notifsCount: 0 }));
    }
    setmarkingAsRead(false);
  };
  const handlePageChange = async (page) => {
    const temp = { ...pagination };
    setPagination((prev) => ({ ...prev, currentPage: page }));
    temp.currentPage = page;
    await getNotificationsList(temp);
  };
  return (
    <DashboardLayout>
      <div>
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">Dashboard</li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#8b8b8cbf" }}
                  >
                    Notifications
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom-accordion col-12 mb-3">
        {notificationsList?.length > 0 && (
          <div className="constainer-fluid mb-3">
            <div className="d-flex justify-content-end">
              {markingAsRead && (
                <div style={{ marginRight: "10px" }}>
                  <LoadingSpinner size={"small"} />
                </div>
              )}
              <Button
                onClick={() => {
                  handleMarkAllAsRead();
                }}
                className="btn-success"
              >
                <i className="bi bi-plus-circle"></i> Mark All As Aead
              </Button>
            </div>
          </div>
        )}
        {notificationsList?.map((item, index) => (
          <AccordionItem
            key={item.id}
            item={item}
            isOpen={openIndex === index}
            onClick={() => toggleAccordion(index, item.id, item.is_read)}
          />
        ))}
        {notificationsList?.length > 0 ? (
          <div className="constainer-fluid">
            <div className="d-flex justify-content-end">
              <div className="mx-4 py-2">
                <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
              </div>
              <BSPagination
                currentPage={pagination?.currentPage || 1}
                totalPages={pagination?.totalPages || 0}
                onPageChange={handlePageChange}
                siblingCount={2}
                showFirstLast={true}
              />
            </div>
          </div>
        ) : (
          <div className="container-fluid">
            <div className="d-flex justify-content-center">
              <div className="my-20">
                <span className="text-light">
                  You do not have any notifications yet.
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

const styles = {
  accordionItem: {
    marginBottom: "8px",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 2px 5px rgba(0,0,0,0.3)",
    border: "1px solid #444",
    backgroundColor: "#2d2d2d",
  },
  chevronContainer: {
    minWidth: "40px",
    display: "flex",
    flexDirection: "row",
    height: "27px",
    alignItems: "center",
    justifyContent: "space-between",
  },
  notificationDate: {
    fontSize: "10px",
    color: "grey",
    fontWeight: "700",
    marginTop: "3px",
  },
  chevron: { fontSize: "15px", marginLeft: "10px", color: "#aaa" },
  accordionContent: {
    maxHeight: "0",
    overflow: "hidden",
    transition: "max-height 0.3s ease-out",
    backgroundColor: "#2d2d2d",
  },
  accordionContentOpen: { maxHeight: "1000px" },
  accordionContentClosed: { maxHeight: "0" },
  accordionBody: {
    padding: "20px",
    color: "#e0e0e0",
    lineHeight: "1.6",
    whiteSpace: "pre-line",
    // white-space: pre-line;
  },
  notificationImage: {
    maxWidth: "20%",
    marginTop: "10px",
    borderRadius: "8px",
    border: "1px solid #444",
  },
  pageHeader: { marginBottom: "24px", color: "#f0f0f0" },
  breadcrumb: {
    backgroundColor: "transparent",
    color: "#aaa",
    "& .active": { color: "#8b8b8cbf" },
  },
  unreadDot: {
    width: "8px",
    height: "8px",
    borderRadius: "5px",
    backgroundColor: "rgb(57, 255, 20)",
    marginRight: "5px",
  },
};

export default memo(Notifications);
